import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-srm-ticket-list-desktop-skeleton',
  templateUrl: './srm-ticket-list-desktop-skeleton.component.html',
  styleUrl: 'srm-ticket-list-desktop-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgxSkeletonLoaderModule,
  ],
})
export class SrmTicketListDesktopSkeletonComponent {
}
